import React, { Component } from "react";
import { Link } from "react-router-dom";
class CityXTeam_SiteContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      comments: [
        {
          id: 1,
          srcimg: "../assets/img/employees/tomislav.jpeg",
          author: "Tomislav Krnić",
          postions: "CTO & Founder",
          text: "Tomislav ima 20+ godina razvojnog iskustva na desetcima projekata kao voditelj projekata i razvojni inženjer. Poseban interes ima prema automatizaciji procesa i praktičnim rješenjima koja velikom broju korisnika olakšavaju svakodnevnicu.",
          linkedIn: "https://www.linkedin.com/in/tomislavkrnic/",
        },
        {
          id: 2,
          srcimg: "../assets/img/employees/katarina.jpeg",
          author: "Katarina Babić",
          postions: "CLO, Pravna služba",
          text: 'Katarina je uz CityX od prvih dana, te je dio tima kao pravni stručnjak koji ambiciozne planove širenja ne zemlje EU usklađuje s pravnim i poreznim regulativama. Prava Supergirl je 24/7 dostupna našim klijentima dok se u pozadini čuje: "mama, mama", njezine male princeze Mare.',
          linkedIn: "https://www.linkedin.com/in/katarina-babić-223ba418b/",
        },
        {
          id: 3,
          srcimg: "../assets/img/employees/martina.jpeg",
          author: "Martina Šahbaz",
          postions: "CCO, Voditeljica razvoja sadržaja",
          text: 'Martina nam se pridružila krajem 2021. i pokazala kao idealna osoba za upravljanje sadržajem i izazovima marketinga. Srednje ime bi joj bilo "nema problema", što se vidi po kvaliteti sadržaja i uredničke politike koju vodi unutar aplikacije, ali i prema javnim objavama.',
          linkedIn: "https://www.linkedin.com/in/martina-šahbaz-b6a82718/",
        },
        {
          id: 4,
          srcimg: "../assets/img/employees/luka.jpeg",
          author: "Luka Krešić",
          postions: "Lead Web Developer",
          text: "Luka je developersko pojačanje od prvih dana. Izuzetna energija i želja za učenjem čine ga savršenim članom CityX Team-a. Posebna vrlina je osjećaj stvaranja rješenja za krajnjeg korisnika i promišljanje iz ugla korisnika, što developeri često zaborave.",
          linkedIn: "https://www.linkedin.com/in/luka-k-b8449812b/",
        },
        {
          id: 5,
          srcimg: "../assets/img/employees/ante.png",
          author: "Ante Mamić",
          postions: "Sportter, voditelj prodaje",
          text: "Ante je dio tima od svibnja 2022., te je preuzeo funkciju voditelja prodaje projekta Sportter. Kao aktivan nogometaš i poznavatelj tematike, u aktivnim je pripremama idejnog rješenja utemeljenog na stručnim (teoretskim i praktičnim) iskustvima s trenerima i klubovima.",
        },
      ],
    };
  }

  render() {
    return (
      <div id="site-content" className="site-content clearfix">
        <div id="inner-content" className="inner-content-wrap">
          <div
            className="themesflat-spacer clearfix"
            data-desktop={61}
            data-mobile={60}
            data-smobile={60}
          />
          <div className="themesflat-headings style-2 clearfix">
            <h2 className="heading">
              CITY<b>X</b> TEAM
            </h2>
            <div className="sep has-width w80 accent-bg clearfix" />
            <p className="sub-heading font-size-16 line-height-28 text-666 margin-top-27">
              Ovo je CityX team koji čini malu radionicu ozbiljnih aplikativnih
              rješenja koja već pomažu, a u budućnosti će još više biti od
              koristi brzorastućem broju naših korisnika
            </p>
          </div>
          <div
            className="themesflat-spacer clearfix"
            data-desktop={40}
            data-mobile={35}
            data-smobile={35}
          />
          <div
            className="themesflat-content-box clearfix"
            data-margin="0 15px 0 0"
            data-mobilemargin="0 0 0 0"
          >
            <ol className="comment-list style-2">
              {this.state.comments.map((data) => (
                <li className="comment" key={data.id}>
                  <article className="comment-wrap clearfix">
                    <div className="gravatar">
                      <img
                        alt="imagealt"
                        src={data.srcimg}
                        style={{ borderRadius: "200px" }}
                      />
                    </div>
                    <div className="comment-content">
                      <div className="comment-meta">
                        <h6 className="comment-author">{data.author}</h6>
                        <span className="comment-position">
                          {data.postions}
                        </span>
                      </div>
                      <div className="comment-text">
                        <p>{data.text}</p>
                        {data.linkedIn ? (
                          <div className="socials">
                            <a href={data.linkedIn} className="linkedin">
                              <span className="fa fa-linkedin-square" />
                            </a>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </article>
                </li>
              ))}
            </ol>
          </div>
          <div
            className="themesflat-spacer clearfix"
            data-desktop={83}
            data-mobile={60}
            data-smobile={60}
          />
        </div>
      </div>
    );
  }
}

export default CityXTeam_SiteContent;
